/**
 * Passenger Categories Constants
 * Centralizes all passenger type definitions and mappings
 */

/**
 * All valid passenger category types in the system
 */
export const PASSENGER_CATEGORY_TYPES = {
  GENERAL: 'general',
  ADULT: 'adult', // Legacy - maps to GENERAL
  OLDER: 'older', // INSEN/INAPAM/Senior citizens
  SENIOR: 'senior', // Alias for OLDER
  MINOR: 'minor', // Ages 3-11
  CHILD: 'child', // Alias for MINOR
  INFANT: 'infant', // Babies
  STUDENT: 'student', // Students
  TEACHER: 'teacher', // Teachers
  SPECIAL: 'special', // People with disabilities
  PCD: 'pcd', // People with disabilities (alias of SPECIAL)
  DISABILITY: 'disability', // Gratuity — people with disabilities
  DISADVANTAGED_YOUTH: 'disadvantaged_youth', // Gratuity — disadvantaged youth
  CHILD_IN_ARMS: 'child_in_arms', // Gratuity — lap child
  WHEELCHAIR_HANDICAP: 'wheelchair_handicap',
  PET_FRIENDLY: 'pet_friendly',
  OVERSOLD: 'oversold', // Overbooking
};

/**
 * Default passenger category
 */
export const DEFAULT_PASSENGER_CATEGORY = PASSENGER_CATEGORY_TYPES.GENERAL;

/**
 * Overbooked passenger category
 */
export const OVERBOOKED_PASSENGER_CATEGORY = PASSENGER_CATEGORY_TYPES.OVERSOLD;

/**
 * Order of passenger categories for UI and business logic
 * Used for sorting and displaying passengers in a consistent order
 */
export const ORDERED_PASSENGER_CATEGORIES = [
  PASSENGER_CATEGORY_TYPES.GENERAL,
  PASSENGER_CATEGORY_TYPES.OLDER,
  PASSENGER_CATEGORY_TYPES.SPECIAL,
  PASSENGER_CATEGORY_TYPES.DISABILITY,
  PASSENGER_CATEGORY_TYPES.DISADVANTAGED_YOUTH,
  PASSENGER_CATEGORY_TYPES.TEACHER,
  PASSENGER_CATEGORY_TYPES.STUDENT,
  PASSENGER_CATEGORY_TYPES.WHEELCHAIR_HANDICAP,
  PASSENGER_CATEGORY_TYPES.MINOR,
  PASSENGER_CATEGORY_TYPES.CHILD_IN_ARMS,
  PASSENGER_CATEGORY_TYPES.PET_FRIENDLY,
];

/**
 * Mapping between different naming conventions
 * Maps legacy/alternative names to canonical types
 * Used for normalizing passenger types from different sources (search, backend, etc.)
 */
export const PASSENGER_TYPE_ALIASES = {
  adult: PASSENGER_CATEGORY_TYPES.GENERAL,
  general: PASSENGER_CATEGORY_TYPES.GENERAL,
  older: PASSENGER_CATEGORY_TYPES.OLDER,
  senior: PASSENGER_CATEGORY_TYPES.OLDER,
  minor: PASSENGER_CATEGORY_TYPES.MINOR,
  child: PASSENGER_CATEGORY_TYPES.MINOR,
  infant: PASSENGER_CATEGORY_TYPES.INFANT,
  student: PASSENGER_CATEGORY_TYPES.STUDENT,
  teacher: PASSENGER_CATEGORY_TYPES.TEACHER,
  special: PASSENGER_CATEGORY_TYPES.SPECIAL,
  pcd: PASSENGER_CATEGORY_TYPES.SPECIAL,
  disability: PASSENGER_CATEGORY_TYPES.DISABILITY,
  disadvantaged_youth: PASSENGER_CATEGORY_TYPES.DISADVANTAGED_YOUTH,
  child_in_arms: PASSENGER_CATEGORY_TYPES.CHILD_IN_ARMS,
  wheelchair_handicap: PASSENGER_CATEGORY_TYPES.WHEELCHAIR_HANDICAP,
  pet_friendly: PASSENGER_CATEGORY_TYPES.PET_FRIENDLY,
  oversold: PASSENGER_CATEGORY_TYPES.OVERSOLD,
};
/**
 * Passenger types used in search/backend responses
 * These are the canonical types that should be used throughout the app
 */
export const CANONICAL_PASSENGER_TYPES = [
  PASSENGER_CATEGORY_TYPES.GENERAL,
  PASSENGER_CATEGORY_TYPES.INFANT,
  PASSENGER_CATEGORY_TYPES.MINOR,
  PASSENGER_CATEGORY_TYPES.CHILD_IN_ARMS,
  PASSENGER_CATEGORY_TYPES.STUDENT,
  PASSENGER_CATEGORY_TYPES.OLDER,
  PASSENGER_CATEGORY_TYPES.TEACHER,
  PASSENGER_CATEGORY_TYPES.SPECIAL,
  PASSENGER_CATEGORY_TYPES.DISABILITY,
  PASSENGER_CATEGORY_TYPES.DISADVANTAGED_YOUTH,
  PASSENGER_CATEGORY_TYPES.WHEELCHAIR_HANDICAP,
  PASSENGER_CATEGORY_TYPES.PET_FRIENDLY,
];
